<template>
	
</template>

<script>
	export default {
		name:'Logout',
		created()
		{
			window.localStorage.removeItem('authorization');
			window.location.reload();
		}
	}
</script>
